import React, { useEffect, useRef, useState } from 'react';
interface CarouselProps {
  /** Accessible label for the scroll region. */
  label: string;
  /** Cards, each already sized by the caller. */
  children: React.ReactNode;
  /** Number of dot indicators (usually the card count). Omit to hide dots. */
  count?: number;
  className?: string;
}

/**
 * Horizontal snap scroller used across the landing for compact mobile
 * browsing: one card leads, the next peeks in so swiping is obvious.
 */
export function Carousel({
  label,
  children,
  count,
  className = ''
}: CarouselProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [active, setActive] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const card = el.querySelector<HTMLElement>('[data-carousel-card]');
      if (!card) return;
      const step = card.offsetWidth + 12;
      setActive(Math.round(el.scrollLeft / step));
    };
    el.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', onScroll);
  }, []);
  const scrollToIndex = (idx: number) => {
    const el = ref.current;
    if (!el) return;
    const card = el.querySelector<HTMLElement>('[data-carousel-card]');
    if (!card) return;
    el.scrollTo({
      left: idx * (card.offsetWidth + 12),
      behavior: 'smooth'
    });
  };
  return <div className={className} data-id="element-245" data-mp="why9t007ykmc">
      <div ref={ref} role="region" aria-label={label} tabIndex={0} className="scrollbar-hide overflow-x-auto snap-x snap-mandatory focus-visible:outline-none" style={{
      WebkitOverflowScrolling: 'touch'
    }} data-id="element-246" data-mp="wj9er35ehyf1">
        <div className="flex gap-3" data-id="element-247" data-mp="iiyn3xw9ofst">{children}</div>
      </div>

      {count && count > 1 && <div className="flex justify-center gap-1.5 mt-3" data-id="element-248" data-mp="2gyl0s9nwvr5q">
          {Array.from({
        length: count
      }).map((_, idx) => <button key={idx} onClick={() => scrollToIndex(idx)} aria-label={`Ir al elemento ${idx + 1}`} aria-current={idx === active} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${idx === active ? 'w-5 bg-gold' : 'w-1.5 bg-current opacity-25'}`} data-id="element-249" data-mp="2cx981v9qqptb" data-mpi={idx} />)}
        </div>}
    </div>;
}